import { render, staticRenderFns } from "./contentSubTitle.vue?vue&type=template&id=72c23729&scoped=true&"
var script = {}
import style0 from "./contentSubTitle.vue?vue&type=style&index=0&id=72c23729&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c23729",
  null
  
)

export default component.exports